import { getClientSideURL } from '@/utilities/getURL'

/**
 * Processes media resource URL to ensure proper formatting
 * @param url The original URL from the resource
 * @param cacheTag Optional cache tag to append to the URL
 * @returns Properly formatted URL with cache tag if provided
 */
export const getMediaUrl = (url: string | null | undefined, cacheTag?: string | null): string => {
  if (!url) return ''

  const qs = cacheTag ? `?t=${encodeURIComponent(cacheTag)}` : ''

  // Already absolute — return as-is
  if (url.startsWith('http://') || url.startsWith('https://')) {
    return `${url}${qs}`
  }

  // Relative path — keep relative so Next.js image optimization needs no remotePatterns
  if (url.startsWith('/')) {
    return `${url}${qs}`
  }

  // Bare path — prepend base URL
  const baseUrl = getClientSideURL()
  return `${baseUrl}/${url}${qs}`
}
